const React = require("react");
const {Close: CloseIcon} = require("@material-ui/icons");

const withState = require("../../../../../../../../../../../../utils/withState");
import ButtonAccept from '../../../../../../../../../../../dumb/Button/Accept';


const MobileFieldsDisplay = require("../MobileFieldsDisplay");

module.exports = withState((setState, self) => {

  self.state = {
    ...self.state,
    data: self.props.data
  }

  return ({data}, {onChange, onClose, ...props}) => {
    return (
      <div className="w320 h pv20 layoutRow fxdColumn pl30 pr40">
        <div className="layoutRow aiC pb20">
          <div className="pr20 mr10 crPointer dB>svg" onClick={onClose}>
            <CloseIcon className="c0" />
          </div>
          <span className="f18 fw6">
          Filters
        </span>
        </div>
        <div className="h1 bgDADCE1 w"/>
        <div className="pv20">
          <MobileFieldsDisplay
            {...props}
            data={data}
            onChange={(data) => {
              setState({data})
            }}
          />
        </div>
        <div className="mtAuto">
          <ButtonAccept
            onClick={() => {
              onChange(data);
              onClose();
            }}
          >
            Accept
          </ButtonAccept>
        </div>
      </div>
    )
  }
})
